import DownloadIcon from 'components/Icons/DownloadIcon';
import ExampleFile from 'download/arquivoGuiaImportacaoBeneficiarios.csv';
import ExampleFileDeactivation from 'download/modeloDeExclusao.csv';

import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  handleShowInstructions: () => void;
  title?: string;
  downloadArchive: string;
}

type DownloadExampleMap = {
  arquivoGuiaImportacaoBeneficiarios: string;
  modeloDeExclusao: string;
};

const IncludeModalButtons: React.FC<Props> = ({ handleShowInstructions, title, downloadArchive }) => {
  const { t } = useTranslation(['includeTeam']);

  const downloadExampleMap: DownloadExampleMap = {
    arquivoGuiaImportacaoBeneficiarios: ExampleFile,
    modeloDeExclusao: ExampleFileDeactivation,
  };

  const downloadArhive = downloadExampleMap[downloadArchive];

  return (
    <>
      <span className="text">{title}</span>
      <div className="button-wrapper">
        <a
          href={downloadArhive}
          download={downloadArchive}
          target="_blank"
          rel="noreferrer"
          className="download-anchor"
        >
          <button type="button" className="download-button">
            {t('includeTeam:download_model')}
            <DownloadIcon />
          </button>
        </a>
        <button
          type="button"
          className="instructions-button"
          onClick={handleShowInstructions}
          data-testid="test-show-instructions"
        >
          {t('includeTeam:access_instructions')}
        </button>
      </div>
    </>
  );
};

export default IncludeModalButtons;
